<script lang="ts">
    import { Icon } from "svelte-materialify/src";
    import { mdiCopyright } from "@mdi/js";

    const year: number = new Date().getFullYear();
</script>

<footer class="footer primary-text d-flex align-center justify-center">
    <Icon path={mdiCopyright} class="primary-text mr-2" />{year} Alexander Carpenter.
    All Rights Reserved
</footer>

<style>
    .footer {
        width: 100% !important;
        bottom: 0 !important;
    }
</style>
